import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import {
  INewPullQuoteFields,
  SpecificLocaleFields,
} from "~/@types/generated/contentful";
import { getComponentFromContentfulRichTextEntry } from "~/contentful";
import {
  InsightComponentData,
  useComponentData,
} from "~/contexts/ComponentDataProvider";

type NewPullQuoteProps = {
  fields: SpecificLocaleFields<INewPullQuoteFields>;
};

export default function NewPullQuote({ fields }: NewPullQuoteProps) {
  const { insight } = useComponentData() as InsightComponentData;

  return (
    <div
      data-content-type="newPullQuote"
      data-module-title={fields.moduleTitle}
      className="h2 global-grid relative z-[1] col-span-full mt-10 flex justify-center py-20"
    >
      <span className="article-columns inline-block indent-20 text-white lg:col-span-10 lg:col-start-2">
        <span
          style={{ backgroundColor: insight?.fields.topic?.fields.color }}
          className={`[&>*]:h2 [&>*]:inline [&>p>span]:inline ${
            insight ? "" : " bg-charcoal"
          }`}
        >
          {!fields.removeQuoteMarks && `“`}
          {fields.body &&
            documentToReactComponents(
              fields.body,
              getComponentFromContentfulRichTextEntry,
            )}
          {!fields.removeQuoteMarks && "”"}
        </span>
      </span>
      <span className="absolute -left-[100vw] -right-[100vw] top-0 bottom-0 -z-10 bg-slate" />
    </div>
  );
}
